import { createSlice, createSelector } from '@reduxjs/toolkit';
import { Annotation } from '@api/domain/types/annotations';
import { RootState } from '@store/types';
import {
  addAnnotationAction,
  clearAnnotationsForPageAction,
  removeAnnotationAction,
  setAnnotationsForPageAction,
  updateAnnotationAction,
} from './actions';

export interface AnnotationsState {
  byDocument: Record<number, Record<number, Annotation[]>>;
}

const initialState: AnnotationsState = {
  byDocument: {},
};

const annotationsSlice = createSlice({
  name: 'annotationsV2',
  initialState,
  reducers: {
    addAnnotation: addAnnotationAction,
    updateAnnotation: updateAnnotationAction,
    removeAnnotation: removeAnnotationAction,
    setAnnotationsForPage: setAnnotationsForPageAction,
    clearAnnotationsForPage: clearAnnotationsForPageAction,
  },
});

export const {
  addAnnotation,
  updateAnnotation,
  removeAnnotation,
  setAnnotationsForPage,
  clearAnnotationsForPage,
} = annotationsSlice.actions;

const EMPTY_ANNOTATIONS: Annotation[] = [];

const selectAnnotationsByDocument = (state: RootState) => state.annotationsV2.byDocument;

export const selectAnnotationsForPage = (documentId: number | null | undefined, pageNumber: number) =>
  createSelector([selectAnnotationsByDocument], (byDocument) => {
    if (documentId == null) {
      return EMPTY_ANNOTATIONS;
    }
    return byDocument[documentId]?.[pageNumber] ?? EMPTY_ANNOTATIONS;
  });

export const selectAllAnnotationsForDocument = (documentId: number | null | undefined) =>
  createSelector([selectAnnotationsByDocument], (byDocument) => {
    if (documentId == null) {
      return {} as Record<number, Annotation[]>;
    }
    return byDocument[documentId] ?? ({} as Record<number, Annotation[]>);
  });

export default annotationsSlice.reducer;
